export default __webpack_public_path__ + "static/media/Gal-bearileo-1.aa606df7.png";